// Library imports.
import axios, { AxiosResponse } from "axios";
import axiosInstance from '../axiosInstance';
import { baseWorker } from "../baseWorker";

// App imports.
import { config } from "../config";


export enum IndexCodeEnum {
     TargetingIndex = "TARGET",
     BurdenReductionIndex = "BURDEN",
     NotSet = ""
}
export enum IndexRadioOptionsEnum {
  All = "ALL",
  GreaterThan = "GREATER",
  LessThan = "LESS",
  EqualTo = "EQUAL",
  Between = "BETWEEN"
}
export interface IIndexResults {
     IndexYears: IIndexYear[];
     RegionIndices: IGranteeRegionIndexYear[];
}
export interface IIndexYear {
     Year: number;
     BurdenReductionIndex: number;
     BenefitTargetingIndex: number;
     NatlAvgBurdenReductionIndex: number;
     NatlAvgBenefitTargetingIndex: number;
     HouseholdsAssisted: number;
     HouseholdsCompleteData: number;
}
export interface IGranteeRegionIndexYear {
     Year: number;
     GranteeName: string;
     BurdenReductionIndex: number;
     BenefitTargetingIndex: number;
     RegionName: string;
     RegAvgBurdenReductionIndex: number;
     RegAvgBenefitTargetingIndex: number;
     HouseholdsAssisted: number;
     HouseholdsCompleteData: number;
}
export interface IGranteeHouseholdsServed {
     Year: number;
     GranteeId: number;
     GranteeName: string;
     HouseholdsAssisted: number;
     HouseholdsCompleteData: number;
     PercentCompleteDataString: string;
}


export class PerformanceDataWorker extends baseWorker {
     public async getGranteeIndexResults(granteeId: number): Promise<IIndexResults> {

          
          const response: AxiosResponse =
               //using the apiBaseURL property defined in config.ts which we import above
               await axiosInstance.get(`${config.apiBaseURL}/pmi/granteeindices/${granteeId}`); 

          const yearsReturned: IIndexYear[] = [];
          response.data[0].forEach(r => {
               const year: IIndexYear = {
                    Year: r.YEAR,
                    BurdenReductionIndex: r.BURDEN_REDUCTION_INDEX,
                    BenefitTargetingIndex: r.BENEFIT_TARGETING_INDEX,
                    NatlAvgBurdenReductionIndex: r.BURDEN_REDUCTION_INDEX_AVG,
                    NatlAvgBenefitTargetingIndex: r.BENEFIT_TARGETING_INDEX_AVG,
                    HouseholdsAssisted: r.HOUSEHOLDS_ASSISTED,
                    HouseholdsCompleteData: r.HOUSEHOLDS_COMPLETE_DATA
               };
               yearsReturned.push(year);
          });

          const regionsReturned: IGranteeRegionIndexYear[] = [];
          response.data[1].forEach(r => {
               const grantee: IGranteeRegionIndexYear = {
                    GranteeName: r.GRANTEE_NAME,
                    Year: r.YEAR,
                    BurdenReductionIndex: r.BURDEN_REDUCTION_INDEX,
                    BenefitTargetingIndex: r.BENEFIT_TARGETING_INDEX,
                    RegionName: r.REGN_DESC,
                    RegAvgBurdenReductionIndex: r.BURDEN_REDUCTION_INDEX_REG_AVG,
                    RegAvgBenefitTargetingIndex: r.BENEFIT_TARGETING_INDEX_REG_AVG,
                    HouseholdsAssisted: r.HOUSEHOLDS_ASSISTED,
                    HouseholdsCompleteData: r.HOUSEHOLDS_COMPLETE_DATA

               };
               regionsReturned.push(grantee);
          });
          let results: IIndexResults = {
               IndexYears: yearsReturned,
               RegionIndices: regionsReturned
          }
          return results;
     }


     public async getHouseholdsServedForGrantees(inStates: number[]): Promise<IGranteeHouseholdsServed[]> {
          //pass parameter in FormData object because Php expects form encoded POST
          const formData = new FormData();
          inStates.forEach(granId => {
               formData.append('states' + '[]', String(granId));
          });

          
          const response: AxiosResponse =
               //using the apiBaseURL property defined in config.ts which we import above
               await axiosInstance.post(`${config.apiBaseURL}/stateslikeme/householdsservedforgrantees`,formData);               
          const granteeHouseholdsServed: IGranteeHouseholdsServed[] = [];
          response.data.forEach(r => {
               const year: IGranteeHouseholdsServed = {
                    Year: r.YEAR,
                    GranteeId: r.GRAN_ID,
                    GranteeName: r.GRANTEE_NAME,
                    HouseholdsAssisted: +r.HOUSEHOLDS_ASSISTED,
                    HouseholdsCompleteData: +r.HOUSEHOLDS_COMPLETE_DATA,
                    PercentCompleteDataString: ''
               };
               if (+r.HOUSEHOLDS_COMPLETE_DATA > 0 && +r.HOUSEHOLDS_ASSISTED > 0) {
                    year.PercentCompleteDataString = ((+r.HOUSEHOLDS_COMPLETE_DATA / +r.HOUSEHOLDS_ASSISTED) * 100).toFixed() + '%';
               }
               granteeHouseholdsServed.push(year);
          });
          return granteeHouseholdsServed;
     }
}
